module.exports = __webpack_public_path__ + "static/img/__9095.ef0d8fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9095.jpg
// module id = 8Yf6
// module chunks = 0